import { Tooltip, Switch } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useMemo } from 'react';
import { useTranslation } from '@hotjar/translations';

// can be removed once global insights styles are removed
const StyledSwitch = styled(Switch)`
  margin-bottom: 0;
`;

export const ActivationSwitch = ({
  onToggle,
  isEnabled,
  hasPermission,
  name,
}: {
  onToggle: () => void;
  isEnabled: boolean;
  hasPermission: boolean;
  name: string;
}): JSX.Element => {
  const { t } = useTranslation('feedback');

  const text = useMemo(() => {
    if (!hasPermission) return t('activation-switch.no-permission');
    return isEnabled ? t('activation-switch.deactivate') : t('activation-switch.activate');
  }, [isEnabled, hasPermission, t]);

  return (
    <Tooltip placement="top" text={text}>
      <span>
        <StyledSwitch
          size="s"
          aria-label={name}
          isDisabled={!hasPermission}
          isChecked={isEnabled === true}
          onChange={onToggle}
        />
      </span>
    </Tooltip>
  );
};
